import { Tooltip } from "@mui/material"
import {
  CancelFilledOutlined,
  CheckCircleFilledOutlined,
  DoNotDisturbOnFilledOutlined,
  PendingOutlined,
  WarningOutlined,
} from "@mui-symbols-material/w300"
import type { FC, ReactElement } from "react"

import { InventoryLotStack } from "../../../../components"
import { getInventoryLotKey } from "../../utils"

import type { InventoryByPalletItemLot, ProductTestStatus } from "@/graphql/codegen/graphql"
import { ProductTestStatus as ProductTestStatusEnum } from "@/graphql/codegen/graphql"

const STATUS_TO_METADATA: Record<ProductTestStatus, { label: string; icon: ReactElement }> = {
  [ProductTestStatusEnum.Approved]: {
    label: "Approved",
    icon: <CheckCircleFilledOutlined fontSize='small' className='text-tertiary-green-500' />,
  },
  [ProductTestStatusEnum.OnHold]: {
    label: "On Hold",
    icon: <WarningOutlined fontSize='small' className='text-tertiary-yellow-500' />,
  },
  [ProductTestStatusEnum.Rejected]: {
    label: "Rejected",
    icon: <CancelFilledOutlined fontSize='small' className='text-secondary' />,
  },
  [ProductTestStatusEnum.Pending]: {
    label: "Pending",
    icon: <PendingOutlined fontSize='small' className='text-gray-600' />,
  },
  [ProductTestStatusEnum.DirectShip]: {
    label: "Not Evaluated",
    icon: <DoNotDisturbOnFilledOutlined fontSize='small' className='text-gray-400' />,
  },
}

interface ProductInventoryPalletLotNumberStackProps {
  lots: InventoryByPalletItemLot[] | null | undefined
}

export const ProductInventoryPalletLotNumberStack: FC<ProductInventoryPalletLotNumberStackProps> = ({ lots }) => (
  <InventoryLotStack
    lots={lots}
    getKey={getInventoryLotKey}
    render={(lot) => {
      const { label, icon } = STATUS_TO_METADATA[lot?.status ?? ProductTestStatusEnum.DirectShip]

      return (
        <span className='flex items-center gap-x-1'>
          <Tooltip title={label} placement='top'>
            {icon}
          </Tooltip>
          <span className='whitespace-nowrap'>{lot.lotNumber}</span>
        </span>
      )
    }}
  />
)
